import Vue from 'vue'
import Vuex from 'vuex'
import API from '@/api/index'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uid: localStorage.getItem("uid") || "",
    token: localStorage.getItem("token") || "",
    nickName: localStorage.getItem("nickName") || "",
    isAdmin: localStorage.getItem("isAdmin") || "",
    collapseVal: localStorage.getItem("collapse") || "",
    requestList: [],
    permissions: "",
  },
  getters: {
    isCollapse(state) {
      return state.collapseVal === "1";
    }
  },
  mutations: {
    // 存储登录信息
    setLoginInfo(state, {uid,token,nickName,isAdmin}) {
      localStorage.setItem("uid", state.uid = uid);
      localStorage.setItem("token",  state.token = token);
      localStorage.setItem("nickName", state.nickName = nickName);
      localStorage.setItem("isAdmin", state.isAdmin = isAdmin);
    },
    //存储请求
    setRequestList(state, val) {
      state.requestList = val;
    },
    // 存储权限
    setPermission(state, val) {
      state.permissions = val;
    },
    // 存储接口权限
    setApi(state, list = []) {
      const apis = {};
      Object.entries(API).forEach(([key, val]) => {
        const id = `${val.method}_/adm/v3/${val.url}`;
        list.includes(id) && (apis[key] = id)
      })
      state.apis = apis;
    },
    // 切换collapse
    switchCollapse(state) {
      let val = state.collapseVal ? "" : "1";
      state.collapseVal = val;
      localStorage.setItem("collapse", val);
    },
    // 清空数据
    clearData (state) {
      Object.keys(state).forEach(key => state[key] = "");
      state.collapseVal = document.body.clientWidth <= 1050 ? "1" : "";
    }
  },
  actions: {
  },
  modules: {
  }
})
